import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { createUseStyles } from 'react-jss'


export const iconsKeys = {
  Logo: 'logo',
  Fall21: 'fall21',
  Close: 'close',
  ToGrid: 'togrid',
  ToCarousel: 'tocarousel',
  Infos: 'infos',
  LeftStick: 'leftstick',
  RightStick: 'rightstick',
  RotateScreen: 'rotatescreen',
  FatArrowRight: 'fatarrowright',
  LogoGame: 'logogame',
  LogoGameError: 'logogameerror',
  Mouse: 'mouse',
  SocialDownload: 'social-download',
  SocialFacebook: 'social-facebook',
  SocialInstagram: 'social-instagram',
  SocialTwitter: 'social-twitter',
  SocialWechat: 'social-wechat',
  SocialWeibo: 'social-weibo',
}

/**
 * @param {Function} Component
 * @param {number} width
 * @param {number} height
 */
const IconWrapper = (fileName, width, height) => {
  const useStyles = createUseStyles()

  const IconAsset = (props) => {
    const classes = useStyles(props)
    const { className } = props

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        className={cx(classes.asset, className)}
      >
        <use xlinkHref={`/icones/spritemap.svg#${fileName}`} />
      </svg>
    )
  }

  IconAsset.useStyles = useStyles
  IconAsset.propTypes = {
    className: PropTypes.string,
  }
  IconAsset.defaultProps = {
    className: '',
  }

  return IconAsset
}

export const icons = {
  [iconsKeys.Logo]: IconWrapper('logo', 217, 25),
  [iconsKeys.Fall21]: IconWrapper('fall21', 62, 14),
  [iconsKeys.Close]: IconWrapper('close', 15, 15),
  [iconsKeys.ToGrid]: IconWrapper('togrid', 15, 15),
  [iconsKeys.ToCarousel]: IconWrapper('tocarousel', 15, 15),
  [iconsKeys.Infos]: IconWrapper('infos', 15, 15),
  [iconsKeys.LeftStick]: IconWrapper('leftstick', 95, 95),
  [iconsKeys.RightStick]: IconWrapper('rightstick', 95, 95),
  [iconsKeys.RotateScreen]: IconWrapper('rotatescreen', 96, 102),
  [iconsKeys.FatArrowRight]: IconWrapper('fatarrowright', 49, 18),
  [iconsKeys.LogoGame]: IconWrapper('logogame', 250, 44),
  [iconsKeys.LogoGameError]: IconWrapper('logogameerror', 144, 32),
  [iconsKeys.Mouse]: IconWrapper('mouse', 79, 140),
  [iconsKeys.SocialDownload]: IconWrapper('social-download', 10, 12),
  [iconsKeys.SocialFacebook]: IconWrapper('social-facebook', 7, 13),
  [iconsKeys.SocialInstagram]: IconWrapper('social-instagram', 12, 12),
  [iconsKeys.SocialTwitter]: IconWrapper('social-twitter', 12, 10),
  [iconsKeys.SocialWechat]: IconWrapper('social-wechat', 14, 13),
  [iconsKeys.SocialWeibo]: IconWrapper('social-weibo', 14, 12),
}

export default icons
